/**
* Created For: 公用搜索条
* this.$emit("input",val)  this.$emit("enter",this.keyword)  this.$emit("blur",this.keyword)
* Author: xuRui.
* Date: 2019/12/30  11:26.
*/
<template>
  <div class="purchase-detail-box">
    <v-title
      title="购进详情"
      :isShowBack="true"
      :isDefaultBack="false"
      @backHandle="goBack()"
    ></v-title>
    <div class="purchase-header" v-show="loading === false">
      <h4>{{ clientDetail.clientName }}</h4>
      <div class="purchase-header-list">
        <div class="purchase-header-item clearfix">
          <span class="fl">统计时间：{{ detailData.timeSpan }}</span>
          <span class="fr">覆盖次数：{{ detailData.frequency }}</span>
        </div>
        <div class="purchase-header-item clearfix">
          <span class="fl">购进数量：{{ detailData.count }}</span>
          <span
            class="fr"
          >购进金额：{{ detailData.totalPrice | dateFormat }}</span
          >
        </div>
      </div>
    </div>
    <div class="purchase-main">
      <div
        class="purchase-main-list"
        v-for="(item, index) in detailData.scaClientSearchTradingCompanyList"
        :key="index"
      >
        <h4>{{ item.tradingCompany }}</h4>
        <div
          class="purchase-main-list-item clearfix"
          v-for="(_item, _index) in item.drugList"
          :key="_index"
        >
          <div class="fl SKU-name">
            {{ _item.drugName }}
          </div>
          <div class="fr price-box">
            <div class="count">
              <span class="ride-icon">x</span
              ><span class="count-number">{{ _item.count }}</span>
            </div>
            <div class="price">￥{{ _item.totalPrice | dateFormat }}</div>
          </div>
        </div>
        <p class="total-price">
          合计 <span>￥{{ item.totalPrice | dateFormat }}</span>
        </p>
      </div>
    </div>
    <!--加载中-->
    <custom-loading v-if="loading" :isMask="true"></custom-loading>
  </div>
</template>

<script>
import { purchaseDetail } from '@/api/feedBack'
import CustomLoading from '@/components/CustomLoading.vue'
export default {
  name: 'PurchaseDetail',
  components: {
    CustomLoading
  },
  created () {
    this.clientDetail = JSON.parse(this.$route.query.data)
    console.log('////////')
    this.searchData = JSON.parse(this.$route.query.searchData)
    console.log(this.$route.query.searchData)
    this.getdetailSecond()
  },
  data () {
    return {
      loading: false,
      keyword: '',
      clientDetail: '',
      detailData: '',
      searchData: '',
      purchaseDetailList: [
        {
          name: '北京九州通医药有限公司',
          list: [
            {
              SKU: '复方酮康唑发用洗剂5ml Rx',
              price: 21.14,
              count: 2
            },
            {
              SKU: '复方酮康唑发用洗剂5ml Rx',
              price: 21.14,
              count: 2
            }
          ]
        },
        {
          name: '北京九州通医药有限公司',
          list: [
            {
              SKU: '复方酮康唑发用洗剂5ml Rx',
              price: 21.14,
              count: 2
            }
          ]
        }
      ]
    }
  },
  computed: {},

  filters: {
    dateFormat (num) {
      num = num + ''
      if (!num.includes('.')) {
        num += '.'
      }
      return num
        .replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        })
        .replace(/\.$/, '')
      // console.log((value + '').replace(/(\d{1,3})(?=(\d{3})+$)/g, '$1,'))
      // return (value + '').replace(/(\d{1,3})(?=(\d{3})+$)/g, '$1,')
    }
  },
  methods: {
    getdetailSecond () {
      this.loading = true
      console.log('/////////////?????')
      console.log(this.searchData)
      const params = {
        ...this.searchData,
        clientId: this.clientDetail.matchClientId
      }

      purchaseDetail(params).then((res) => {
        if (res.code === 1) {
          this.loading = false
          this.detailData = res.data
        }
      })
    },
    goBack () {
      // this.$router.push({name:'index'})
      this.$router.back()
    },
    // 回车事件
    submitHandle () {
      this.$emit('enter', this.keyword)
    },
    // 失去焦点时
    blurHandle () {
      this.$emit('blur', this.keyword)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/base/base.styl';

.search-bar {
  width: 100%;
  height: 64px;
  padding: 0 88px;
  background: $color-gray;
  position: relative;
  vertical-align: top;
  overflow: hidden;

  .search-input {
    width: 100%;
    height: 40px;
    font-size: $font-XL;
    line-height: 40px;
    margin-top: 12px;
  }

  .sprite {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);

    &.icon-search {
      left: 21px;
    }

    &.icon-close {
      right: 21px;
    }
  }
}

.purchase-detail-box {
  height: 100%;
  background: #efefef;
}

.purchase-header {
  padding: 36px 32px;
  padding-top: 110px;
  background: #fff;

  h4 {
    font-size: 30px;
    color: #333;
    font-weight: bold;
  }

  .purchase-header-list {
    .purchase-header-item {
      margin-top: 24px;
      color: #666;
      font-size: 26px;
    }
  }
}

.purchase-main {
  .purchase-main-list {
    background: #fff;
    margin-top: 20px;

    h4, .purchase-main-list-item {
      width: 686px;
      margin: 0 auto;
    }

    h4 {
      padding-top: 36px;
      line-height: 1;
      color: #333;
      font-size: 30px;
      font-weight: bold;
    }

    .purchase-main-list-item {
      border-bottom: 1px solid #efefef;
      padding-bottom: 36px;
      padding-top: 26px;
      color: #666;
      line-height: 1;
      font-size: 26px;

      &:last-of-type {
        border-bottom: none;
      }

      .price-box {
        text-align: end;

        .count {
          .ride-icon {
            margin-right: 14px;
          }
        }

        .price {
          margin-top: 26px;
          color: #ed4276;
          font-size: 26px;
        }
      }
    }

    .total-price {
      border-top: 1px solid #efefef;
      color: #333;
      font-size: 26px;
      font-weight: bold;
      text-align: end;
      line-height: 85px;
      height: 85px;
      padding: 0 32px;

      span {
        font-weight: bolder;
        color: #ed4276;
      }
    }
  }
}
</style>
<style scoped>
</style>
